import { useEffect } from "react";

import { useThunkDispatch } from "@/redux/dispatcher";
import { set as setLocales } from "@/redux/modules/value/locales/locales.module";
import { Config } from "@/utils/config.utils";

import LanguageSelector from "./languageSelector.component";

type LanguageSelectorContainerProps = {
    layout: "default" | "list" | "toggle";
    variant?: string;
};

export const LanguageSelectorContainer = ({
    layout,
    variant
}: LanguageSelectorContainerProps) => {
    const dispatch = useThunkDispatch();

    useEffect(() => {
        dispatch(
            setLocales({
                current: Config.general.locale,
                languages: Config.languages
            })
        );
    }, [dispatch]);

    return (
        <LanguageSelector
            layout={layout || "default"}
            variant={variant}
        />
    );
};
